export function isCustomizationEnabled(customization: {
  enablement?: ReadonlyArray<{enabled: boolean}>
  enabled?: unknown
}): boolean {
  if ('enablement' in customization) return customization.enablement?.[0]?.enabled !== false
  return customization.enabled !== false
}
